import { apiSlice } from "redux/api/baseApiSlice";

export const authApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        loginWithCookies: builder.mutation<void, {username: string, password: string}>({
            query: (credentials) => ({
                url: '/auth/login/',
                method: 'POST',
                body: {...credentials}
            })
        }),
        refreshCookies: builder.mutation({
            query: () => ({
                url: '/auth/refresh/',
                method: 'POST'
            })
        }),
        logout: builder.mutation<void , void>({
            query: () => ({
                url: '/auth/logout/',
                method: 'POST'
            })
        }),
        authenticationFromRiskapp: builder.mutation<void, {uuid: string}>({
            query: (uuid) => ({
                url: '/auth/login_from_redirect_token/',
                method: 'POST',
                body: uuid
            })
        }),
        getErikUrl: builder.mutation<{ erik_url: string; token: string }, void>({
            query: () => ({
                url: '/negotiation/negotiations/get_erik_token',
                method: 'POST',
            }),
        }),
    })
})

export const {useLoginWithCookiesMutation, useLogoutMutation, useAuthenticationFromRiskappMutation, useGetErikUrlMutation} = authApiSlice